import { useEffect, useState } from "react";

const SPIN_MS   = 1400;
const FADE_MS   = 400;

export default function SplashAnimation({ logo, onDone }) {
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setOpacity(0), SPIN_MS);
    const doneTimer = setTimeout(onDone, SPIN_MS + FADE_MS);
    return () => { clearTimeout(fadeTimer); clearTimeout(doneTimer); };
  }, [onDone]);

  return (
    <>
      <style>{`
        @keyframes splashSpin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>
      <div style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "#060912",
        display: "flex", alignItems: "center", justifyContent: "center",
        opacity, transition: `opacity ${FADE_MS}ms ease`,
        pointerEvents: "none",
      }}>
        <img
          src={logo}
          alt="SA Connections"
          style={{
            width: 80, height: 80,
            objectFit: "contain",
            animation: `splashSpin 0.7s linear infinite`,
          }}
        />
      </div>
    </>
  );
}
